import { render, staticRenderFns } from "./invoice-payment.vue?vue&type=template&id=37b44af0"
import script from "./invoice-payment.vue?vue&type=script&lang=js"
export * from "./invoice-payment.vue?vue&type=script&lang=js"
import style0 from "./invoice-payment.vue?vue&type=style&index=0&id=37b44af0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports